/* Anatomie de Noël — logique page produit */
(function () {
  var el = document.getElementById('adn-data');
  if (!el) return;
  var D = JSON.parse(el.textContent);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var T = D.i18n;
  var PREVIEW = !!window.ADN_PREVIEW;

  function money(cents) {
    var fmt = D.moneyFormat || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var thousands = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var out = fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, thousands(parts[0], '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, thousands(parts[0], '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, thousands(parts[0], ','))
      .replace(/\{\{\s*amount\s*\}\}/, thousands(parts[0], ',') + '.' + parts[1]);
    out = out.replace(/<[^>]+>/g, '').trim();
    if (/^€\s?/.test(out)) out = out.replace(/^€\s?/, '') + ' €';
    return out;
  }
  function fill(tpl, o) { return tpl.replace(/\[(\w+)\]/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }
  function toast(msg) {
    var t = $('[data-adn-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }

  /* ---------- Galerie ---------- */
  var media = D.product.media || [];
  var slides = $('[data-slides]'), dots = $('[data-dots]'), thumbs = $('[data-thumbs]');
  media.forEach(function (m, i) {
    var img = document.createElement('img');
    img.src = m.src; img.alt = m.alt || ''; img.loading = i ? 'lazy' : 'eager';
    if (!i) img.fetchPriority = 'high';
    img.width = 1200; img.height = 1200;
    slides.appendChild(img);
    var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Photo ' + (i + 1));
    d.onclick = function () { go(i); }; dots.appendChild(d);
    var tb = document.createElement('button'); tb.type = 'button'; tb.setAttribute('aria-label', 'Photo ' + (i + 1));
    tb.innerHTML = '<img src="' + (m.thumb || m.src) + '" alt="" loading="lazy">';
    tb.onclick = function () { go(i); }; thumbs.appendChild(tb);
  });
  if (media.length < 2) { dots.hidden = true; thumbs.hidden = true; }
  function go(i) { slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' }); }
  function markActive() {
    var i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
    $$('button', dots).forEach(function (b, j) { b.setAttribute('aria-current', j === i); });
    $$('button', thumbs).forEach(function (b, j) { b.setAttribute('aria-current', j === i); });
  }
  slides.addEventListener('scroll', function () { cancelAnimationFrame(markActive._r); markActive._r = requestAnimationFrame(markActive); });
  markActive();

  /* ---------- Packs & prix ---------- */
  var V = D.product.variants || [];
  var unit = V[0] ? V[0].price : 0;
  var sel = 0;
  var bundles = $$('[data-bundle]');
  bundles.forEach(function (b, i) {
    var v = V[i];
    if (!v) { b.hidden = true; return; }
    var qty = i + 1, full = Math.max(v.compare || 0, unit * qty);
    $('[data-bp]', b).textContent = money(v.price);
    var bc = $('[data-bc]', b);
    if (bc) bc.textContent = full > v.price ? money(full) : '';
    var each = $('[data-each]', b);
    if (each) each.textContent = fill(T.each, { price: money(Math.round(v.price / qty)), save: money(full - v.price) });
    b.addEventListener('click', function () { sel = i; render(); });
  });
  var addonEls = $$('[data-addon]');
  addonEls.forEach(function (a, i) {
    var ad = D.addons[i];
    if (!ad) { a.hidden = true; return; }
    $('[data-ap]', a).textContent = '+' + money(ad.price);
    $('input', a).addEventListener('change', render);
  });
  function addonTotal() {
    return addonEls.reduce(function (s, a, i) { return s + ($('input', a).checked && D.addons[i] ? D.addons[i].price : 0); }, 0);
  }
  function render() {
    bundles.forEach(function (b, i) { b.classList.toggle('is-on', i === sel); var r = $('input', b); if (r) r.checked = i === sel; });
    var v = V[sel]; if (!v) return;
    var full = Math.max(v.compare || 0, unit * (sel + 1));
    $('[data-price-now]').textContent = money(v.price);
    var was = $('[data-price-was]'), save = $('[data-price-save]');
    if (full > v.price) {
      was.hidden = false; was.textContent = money(full);
      save.hidden = false; save.textContent = fill(T.save, { percent: Math.round((1 - v.price / full) * 100) });
    } else { was.hidden = true; save.hidden = true; }
    var total = v.price + addonTotal();
    $('[data-total]').textContent = money(total);
    var sp = $('[data-sticky-price]'); if (sp) sp.textContent = money(v.price);
  }
  render();
  var fc = $('[data-final-cta]');
  if (fc && V[0]) fc.textContent = fill(fc.getAttribute('data-tpl'), { price: money(V[0].price) });

  /* ---------- Date de livraison ---------- */
  function addBusinessDays(d, n) {
    var r = new Date(d);
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  var lang = D.locale || document.documentElement.lang || 'fr';
  var fmtD = function (d) { return d.toLocaleDateString(lang, { day: 'numeric', month: 'long' }); };
  var now = new Date();
  var dl = $('[data-delivery]');
  if (dl) dl.innerHTML = fill(T.delivery, { from: fmtD(addBusinessDays(now, D.shipMin || 7)), to: fmtD(addBusinessDays(now, D.shipMax || 10)) });

  /* ---------- Compte à rebours ---------- */
  var cd = $('[data-adn-countdown]');
  var end = new Date(D.cutoff || '2026-11-27T23:59:00+01:00').getTime();
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var ms = end - Date.now();
    if (ms <= 0) { cd.innerHTML = '<span>' + T.over + '</span>'; return; }
    var s = Math.floor(ms / 1000);
    $('[data-d]', cd).textContent = pad(Math.floor(s / 86400));
    $('[data-h]', cd).textContent = pad(Math.floor(s % 86400 / 3600));
    $('[data-m]', cd).textContent = pad(Math.floor(s % 3600 / 60));
    $('[data-s]', cd).textContent = pad(s % 60);
    setTimeout(tick, 1000);
  }
  if (cd) tick();

  /* ---------- Panier ---------- */
  var drawer = $('[data-adn-drawer]'), overlay = $('[data-adn-overlay]');
  var fakeCart = { items: [], item_count: 0, total_price: 0, original_total_price: 0 };
  function openCart() { drawer.classList.add('is-on'); overlay.classList.add('is-on'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeCart() { drawer.classList.remove('is-on'); overlay.classList.remove('is-on'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  $$('[data-adn-open-cart]').forEach(function (b) { b.addEventListener('click', function () { refreshCart().then(openCart); }); });
  $$('[data-adn-close]').concat([overlay]).forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closePop(); } });

  function api(url, body) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function getCart() { return PREVIEW ? Promise.resolve(fakeCart) : api('cart.js'); }
  function refreshCart() { return getCart().then(drawCart); }
  function drawCart(c) {
    $$('[data-adn-count]').forEach(function (n) { n.textContent = c.item_count; n.setAttribute('data-n', c.item_count); });
    var box = $('[data-items]');
    if (!c.items.length) { box.innerHTML = '<p class="adn-drawer__empty">' + T.empty + '</p>'; }
    else {
      box.innerHTML = c.items.map(function (it, i) {
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '<span></span>';
        var orig = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        return '<div class="adn-line">' + img + '<div><div class="adn-line__t">' + it.product_title + '</div><div class="adn-line__v">' + vt + '</div>' +
          '<div class="adn-line__q"><button type="button" data-q="' + (i + 1) + '" data-n="' + (it.quantity - 1) + '" aria-label="−">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + (i + 1) + '" data-n="' + (it.quantity + 1) + '" aria-label="+">+</button></div></div>' +
          '<div class="adn-line__p">' + orig + money(it.final_line_price) + '</div></div>';
      }).join('');
      $$('[data-q]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var line = +b.getAttribute('data-q'), q = +b.getAttribute('data-n');
          if (PREVIEW) { var it = fakeCart.items[line - 1]; if (q <= 0) fakeCart.items.splice(line - 1, 1); else it.quantity = q; recalcFake(); return drawCart(fakeCart); }
          api('cart/change.js', { line: line, quantity: q }).then(drawCart);
        });
      });
    }
    var bundleSave = c.items.reduce(function (s, it) { return s + Math.max(0, (it.bundle_full || 0) - it.final_line_price); }, 0);
    var sub = c.original_total_price + bundleSave;
    $('[data-sub]').textContent = money(sub);
    var save = sub - c.total_price, row = $('[data-saverow]');
    row.hidden = save <= 0; $('[data-savings]').textContent = '−' + money(save);
    $('[data-tot]').textContent = money(c.total_price);
    return c;
  }
  function recalcFake() {
    fakeCart.item_count = fakeCart.items.reduce(function (s, i) { return s + i.quantity; }, 0);
    fakeCart.items.forEach(function (i) { i.final_line_price = i.original_line_price = i.price * i.quantity; i.bundle_full = (i.unit_full || i.price) * i.quantity; });
    fakeCart.total_price = fakeCart.original_total_price = fakeCart.items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
  }

  function addToCart(btn) {
    var v = V[sel]; if (!v) return;
    var items = [{ id: v.id, quantity: 1 }];
    addonEls.forEach(function (a, i) { if ($('input', a).checked && D.addons[i]) items.push({ id: D.addons[i].id, quantity: 1 }); });
    var btns = $$('[data-adn-add]');
    btns.forEach(function (b) { b.disabled = true; b.textContent = T.adding; });
    var p;
    if (PREVIEW) {
      items.forEach(function (it, k) {
        var isMain = k === 0;
        var title = isMain ? D.product.title : (k === 1 && $('input', addonEls[0]).checked ? $('b', addonEls[0]).textContent : $('b', addonEls[1]).textContent).replace(/^\S+\s/, '');
        var price = isMain ? v.price : D.addons[addonEls.findIndex(function (a, i) { return $('input', a).checked && D.addons[i] && D.addons[i].id === it.id; })].price;
        var ex = fakeCart.items.find(function (x) { return x.id === it.id; });
        if (ex) ex.quantity++; else fakeCart.items.push({ id: it.id, product_title: title, variant_title: isMain ? v.title : '', quantity: 1, price: price, unit_full: isMain ? unit * (sel + 1) : price, image: isMain && media[0] ? media[0].thumb || media[0].src : null });
      });
      recalcFake(); p = Promise.resolve(fakeCart);
    } else {
      p = api('cart/add.js', { items: items }).then(function () { return api('cart.js'); });
    }
    p.then(function (c) {
      btns.forEach(function (b) { b.textContent = T.added; });
      drawCart(c); openCart();
    }).catch(function () { toast(T.error); }).then(function () {
      setTimeout(function () { btns.forEach(function (b) { b.disabled = false; b.textContent = T.add; }); }, 1200);
    });
  }
  $$('[data-adn-add]').forEach(function (b) { b.addEventListener('click', function () { addToCart(b); }); });
  var ck = $('[data-checkout]');
  if (ck && PREVIEW) ck.addEventListener('click', function (e) { e.preventDefault(); toast('Aperçu : le paiement s’ouvrira sur Shopify'); });

  /* ---------- Barre collante ---------- */
  var sticky = $('[data-adn-sticky]'), mainBtn = $('.adn-box [data-adn-add]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    var past = false;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; sticky.classList.toggle('is-on', past); });
    }).observe(mainBtn);
  }

  /* ---------- Vidéos ---------- */
  var vids = $$('[data-adn-video]');
  if ('IntersectionObserver' in window) {
    var vo = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); }); }, { threshold: .5 });
    vids.forEach(function (v) { vo.observe(v); });
  }
  $$('[data-adn-sound]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.previousElementSibling; var on = v.muted;
      vids.forEach(function (x) { x.muted = true; }); $$('[data-adn-sound]').forEach(function (x) { x.textContent = '🔇'; });
      v.muted = !on; b.textContent = on ? '🔊' : '🔇'; if (on) v.play().catch(function () {});
    });
  });

  /* ---------- Pop-up code promo ---------- */
  var pop = $('[data-adn-pop]');
  function closePop() { if (pop) pop.classList.remove('is-on'); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  if (pop && !store('adn_pop_seen')) {
    var shown = false;
    var show = function () { if (shown) return; shown = true; pop.classList.add('is-on'); store('adn_pop_seen', '1'); };
    setTimeout(show, (D.popupDelay || 12) * 1000);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 5) show(); });
  }
  $$('[data-pop-close]').forEach(function (b) { b.addEventListener('click', closePop); });
  var pa = $('[data-pop-apply]');
  if (pa) pa.addEventListener('click', function () {
    var code = D.popupCode || 'NOEL10';
    var done = function () { closePop(); toast(T.applied); };
    if (PREVIEW) return done();
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' }).then(done, done);
  });
  if (pop) pop.addEventListener('click', function (e) { if (e.target === pop) closePop(); });

  if (!PREVIEW) refreshCart().catch(function () {});
})();
